<roots-page-header title="Reports" toolTip="Generate reports and export their datasets." [loading]="loading || generating"></roots-page-header>
<div class="reports-workspace">
<section class="report-selector report-panel">
  <div class="report-section-heading">
    <span class="report-section-icon"><mat-icon>assessment</mat-icon></span>
    <div><h2>Choose a report</h2><p>Select a report to configure its parameters and generate results.</p></div>
  </div>
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="report-select-field">
    <mat-label>Report</mat-label>
    <mat-select (selectionChange)="chooseUtility($event)" [disabled]="loading || generating">
      <mat-option>
        <ngx-mat-select-search placeholderLabel="Search reports" [formControl]="utilityFilterCtrl"
        noEntriesFoundLabel="No matching reports"></ngx-mat-select-search>
      </mat-option>
      @for (utility of filteredUtilities; track utility) {
        <mat-option value="{{utility.id}}">{{utility.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</section>

@if (selectedUtility == null && !loading) {
  <section class="report-empty report-panel">
    <mat-icon>insert_chart_outlined</mat-icon>
    <h2>{{ utilities?.length ? 'Ready when you are' : 'No reports available' }}</h2>
    <p>{{ utilities?.length ? 'Choose a report above to get started.' : 'No reports were returned. Refresh the page to try again.' }}</p>
  </section>
}
@if (selectedUtility != null) {
  <div>
    <mat-card appearance="outlined" class="report-panel report-configuration">
      <div class="report-section-heading"><span class="report-section-icon"><mat-icon>tune</mat-icon></span><div><h2>{{selectedUtility.name}}</h2>
      <p>{{selectedUtility.description}}</p></div></div>
      <form class="report-setup-form" [formGroup]="parameterFormGroup" (ngSubmit)="generateReport()">
      <div class="report-form-label">Report parameters</div>
      <div class="report-parameter-grid">
        @for (param of selectedUtility.publicInfo.request.parameters; track param; let i = $index) {
          <div>
            @if (param.typeName == 'datetimeoffset') {
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{param.name}}{{param.isOptional ? " (optional)" : "" }}</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="{{param.code}}" [required]="!param.isOptional"
                  (dateChange)="dateInputChange($event.targetElement.value, param.code)">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error>{{dateTimeErrorMessage(param.code, i)}}</mat-error>
              </mat-form-field>
            }
            <!-- <mat-form-field *ngIf="param.type == 'datetimeoffset'" class="form-field col-6">
            <mat-label>{{param.name}}</mat-label>
            <mat-date-range-input [formControlName]="param.code" [rangePicker]="picker" [required]="param.isRequired">
              <input matStartDate [(ngModel)]="param.startDate" placeholder="Start">
              <input matEndDate [(ngModel)]="param.endDate" placeholder="End" (dateChange)="changeDate($event)">
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field> -->
          @if (param.typeName == 'string') {
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{param.name}}{{param.isOptional ? " (optional)" : "" }}</mat-label>
              <textarea matInput type="text" (input)="stringInputChange($event.target.value, param.code)"
                [required]="!param.isOptional" formControlName="{{param.code}}"
              cdkTextareaAutosize></textarea>
              <mat-error>{{stringErrorMessage(param.code, i)}}</mat-error>
            </mat-form-field>
          }
          @if (param.typeName == 'int') {
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{param.name}}{{param.isOptional ? " (optional)" : "" }}</mat-label>
              <input matInput type="number" (input)="numberInputChange($event.target, param.code)"
                [required]="!param.isOptional" formControlName="{{param.code}}" />
              <mat-error>{{numberErrorMessage(param.code, i)}}</mat-error>
            </mat-form-field>
          }
          @if (param.typeName == 'bool') {
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>{{param.name}}</mat-label>
              <input matInput type="number" (input)="numberInputChange($event.target, param.code)" [required]="true"
                formControlName="{{param.code}}" />
              <mat-error>{{numberErrorMessage(param.code, i)}}</mat-error>
            </mat-form-field>
          }
        </div>
      }
      </div>
      <div class="report-form-actions"><p>Generate results using the parameters above.</p><button mat-flat-button type="submit" class="report-primary" [disabled]="!parameterFormGroup.valid || generating">
        <mat-icon>play_arrow</mat-icon>{{ generating ? "Generating…" : "Generate report" }}
      </button></div>
    </form>
    @if (reportGenerated) {
      <div>
        <h2 class="report-results-heading">Report results</h2>
        <mat-tab-group class="report-results" [mat-stretch-tabs]="false" (selectedTabChange)="tabChange($event)">
          @for (dataset of selectedUtility.publicInfo.result.datasets; track dataset; let i = $index) {
            <mat-tab
              label="{{dataset.name}}">
              <div class="report-results-toolbar"><span class="report-row-count">{{ dataSources[i]?.data?.length || 0 }} rows</span><button mat-stroked-button (click)="hideTable = !hideTable" class="report-secondary">
                <mat-icon>table_chart</mat-icon>{{hideTable ? "Show table" : "Hide table"}}
              </button></div>
              <div class="report-table-wrapper" [class.roots-table-card]="!hideTable">
                <mat-table matTableExporter [dataSource]="dataSources[i]" #exporter="matTableExporter" [hidden]="hideTable">
                  @for (column of displayedColumns[i]; track column; let j = $index) {
                    <div>
                      <ng-container matColumnDef="{{displayedColumns[i][j]}}">
                        <mat-header-cell
                        *matHeaderCellDef>{{selectedUtility.publicInfo.result.datasets[i].attributes[j].name}}</mat-header-cell>
                        <mat-cell *matCellDef="let data">{{data[column]}}</mat-cell>
                      </ng-container>
                    </div>
                  }
                  <mat-header-row *matHeaderRowDef="displayedColumns[i]"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns[i];"></mat-row>
                  <div *matNoDataRow class="report-no-data">No rows were returned for these parameters.</div>
                </mat-table>
                <mat-paginator [hidden]="hideTable" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
              </div>
              <div class="report-export"><div class="report-export-heading"><mat-icon>file_download</mat-icon><div><strong>Export this dataset</strong><span>Download the selected results as an Excel file.</span></div></div><mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>File name</mat-label>
                <input matInput [(ngModel)]="fileNames[i]" />
              </mat-form-field>
              <button mat-stroked-button class="report-secondary"
                (click)="exporter.exportTable('xlsx', {fileName:fileNames[i], sheet: 'Report'})">
                <mat-icon>download</mat-icon>Export to Excel
              </button></div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    }
  </mat-card>
</div>
}
</div>
